import styled from "styled-components";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";

export const Title = styled.h2.attrs(() => ({
    className: "l-delta-text",
}))`
    margin-bottom: 4px;
    font-size: 1.8rem;
    line-height: 2.4rem;
    color: ${theme.colors.midnight};
    @media ${getBreakpoint("up", "lg")} {
        font-size: 2.2rem;
        line-height: 2.8rem;
    }
`;

export const Description = styled.p.attrs(() => ({
    className: "l-base-text",
}))`
    margin-bottom: ${theme.space[3]}px;
    color: ${theme.colors.midnight};
`;
